import { TariffsModeDto } from '../dto'
import { TariffsModeModel } from '../model'

export const tariffsModeDtoToModelTransformer = (dto: TariffsModeDto): TariffsModeModel => {
  return {
    mode: dto.mode,
    vendorName: dto.vendorName ?? undefined,
    setting: dto.setting ?? undefined,
  }
}
